import { useState } from "react";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const fyLabel = (fy) => `FY${fy}-${String(fy + 1).slice(2)}`;

// Downloads the Sales Planning workbook (all sheets) or a single tab's sheet.
export function ExportXlsxButton({ sheets = "all", fy, region = "UK", label, size = "sm", variant = "outline", className = "" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const params = new URLSearchParams({ sheets, region });
      if (fy) params.set("fy", String(fy));
      const res = await api.get(`/sales/export?${params.toString()}`, { responseType: "blob", timeout: 180000 });
      const cd = res.headers?.["content-disposition"] || "";
      const name = /filename="?([^"]+)"?/.exec(cd)?.[1] || `SalesPlanning_${region}_${fy ? fyLabel(fy) : "FY"}.xlsx`;
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
      toast.success(`Downloaded ${name}`);
    } catch (e) {
      toast.error("Export failed: " + (e?.response?.data?.detail || e.message));
    } finally { setBusy(false); }
  };
  return (
    <Button variant={variant} size={size} onClick={run} disabled={busy} className={`gap-1.5 ${className}`}
      title={`Export ${sheets === "all" ? "the full workbook" : "this section"} to Excel${fy ? ` · ${fyLabel(fy)}` : ""}`}
      data-testid={`export-xlsx-${sheets.replace(/,/g, "-")}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileSpreadsheet className="w-4 h-4" />}
      {label ?? (sheets === "all" ? "Export Excel" : "Export")}
    </Button>
  );
}
